import React from "react";
import styled from "styled-components";
import FetchingSpinner from "../../../components/spinner/render-prop-spinner";
import HeroTitle from "./hero-title";
import BookGrid from "../bookviews/book-grid";
import BridgeBook from "../book/bridge-book";

const Styled = {
  BookGridContainer: styled.div`
    margin-bottom: 90px;
  `
};

class SmallSubscriptions extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {
      assets,
      allAssetsLoading,
      subscriptionVbid,
      showSearch,
      backToExplore
    } = this.props;
    return (
      <div>
        <HeroTitle
          subscriptionVbid={subscriptionVbid}
          showSearch={showSearch}
          backToExplore={backToExplore}
        />
        <Styled.BookGridContainer>
          <FetchingSpinner
            loading={allAssetsLoading}
            component={() => {
              return (
                <BookGrid
                  BookObject={BridgeBook}
                  isbns={assets.map(b => ({ isbn: b.vbid }))}
                />
              );
            }}
          />
        </Styled.BookGridContainer>
      </div>
    );
  }
}
export default SmallSubscriptions;
